import script from "./SummonLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./SummonLoading.vue?vue&type=script&setup=true&lang=js"

import "./SummonLoading.vue?vue&type=style&index=0&id=1f23933b&lang=css"

const __exports__ = script;

export default __exports__